export default __webpack_public_path__ + "static/rollingMoney-14490205012a717b5fbe29ae853cdbe0.svg";